import { setCurrentSession as e, uniqueId as t } from "./global-state.js";
import { CopilotSession as n } from "./session.js";
import { atom as r, computed as i } from "nanostores";
// src/registry.ts
var a = 6;
function o(e) {
	return e === "sending" || e === "receiving" || e === "recovering";
}
function s(e) {
	return o(e) || e === "initializing";
}
var c = class {
	constructor() {
		this.__entries = r([]), this.__activeKey = r(null), this.__activeSession = i([this.__entries, this.__activeKey], (e, t) => t == null ? null : e.find((e) => e.key === t)?.session ?? null), this.activationClock = 0;
	}
	getActive() {
		return this.__activeSession.get();
	}
	startNew() {
		let e = this.register(new n());
		return this.setActive(e), this.evictIfNeeded(), e.session;
	}
	activateByServerId(e) {
		let t = this.findByServerId(e);
		if (t != null) {
			this.setActive(t);
			let n = t.session.__status.get();
			return n === "error" ? t.session.initialize(e).catch(() => {}) : n === "ready" && t.session.refresh(), t.session;
		}
		let r = this.register(new n());
		return this.setActive(r), this.evictIfNeeded(), r.session.initialize(e).catch(() => {}), r.session;
	}
	findByServerId(e) {
		return this.__entries.get().find((t) => t.session.id === e);
	}
	removeByServerId(e) {
		let t = this.findByServerId(e);
		t != null && (this.__entries.set(this.__entries.get().filter((e) => e.key !== t.key)), t.session.dispose(), this.__activeKey.get() === t.key && this.startNew());
	}
	disposeAll() {
		for (let e of this.__entries.get()) e.session.dispose();
	}
	register(e) {
		let n = Object.assign(e, { reset: () => this.startNew() }), r = {
			key: t(),
			session: n,
			activatedAt: ++this.activationClock
		};
		return this.__entries.set([...this.__entries.get(), r]), r;
	}
	setActive(t) {
		let n = ++this.activationClock;
		this.__entries.set(this.__entries.get().map((e) => e.key === t.key ? {
			...e,
			activatedAt: n
		} : e)), this.__activeKey.set(t.key), e(t.session);
	}
	evictIfNeeded() {
		let e = this.__entries.get();
		if (e.length <= 6) return;
		let t = this.__activeKey.get(), n = e.filter((e) => e.key !== t && !s(e.session.__status.get())).sort((e, t) => e.activatedAt - t.activatedAt).slice(0, e.length - 6);
		if (n.length === 0) return;
		let r = new Set(n.map((e) => e.key));
		this.__entries.set(e.filter((e) => !r.has(e.key)));
		for (let e of n) e.session.dispose();
	}
};
export { c as CopilotSessionRegistry, a as MAX_LIVE_SESSIONS, o as isSessionRunning };
